import { useEffect, useState } from "react";
import { userService } from "../../services/user-service";
import { HistoryDto } from "../../types/dto/history-dto";
import { AdminHomeHistoryHeader } from "../header/AdminHomeHistoryHeader";
import { AdminHomeHistorySimplePanel } from "./AdminHomeHistorySimplePanel";

export const AdminHomeHistoryPanel = () => {
  const [data, setData] = useState<HistoryDto[]>([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [totalPage, setTotalPage] = useState(1);
  const ITEMS_PER_PAGE = 50;

  const getPage = async (pageNum: number) => {
    try {
      const response = await userService.getAdminHomeHistory({
        page: pageNum,
        size: ITEMS_PER_PAGE
      });

      // response: PatchNoteListData & ErrorResponse<void>
      if (response.items && response.meta) {
        const items = response.items;
        const meta = response.meta;
        if (pageNum === 1) {
          setData(items);
        } else {
          setData(prev => [...prev, ...items]);
        }
        setHasMore(!meta.isLast);
        setTotalPage(meta.totalPage);
      }
    } catch (error) {
      console.error("Failed to fetch history:", error);
    }
  };

  useEffect(() => {
    getPage(1);
  }, []);

  const plusPage = async () => {
    const nextPage = page + 1;
    if ((nextPage - 1) * 5 < data.length) {
      setPage(nextPage);
      return;
    }
    if (hasMore) {
      setPage(nextPage);
      await getPage(Math.ceil(data.length / ITEMS_PER_PAGE) + 1);
    }
  };

  const minusPage = () => {
    setPage(prev => Math.max(1, prev - 1));
  };

  // 현재 페이지에 표시할 아이템들
  const currentPageItems = data.slice((page - 1) * 5, page * 5);

  return (
    <div className="flex flex-col">
      <AdminHomeHistoryHeader
        page={page}
        totalPage={totalPage}
        plusPage={plusPage}
        minusPage={minusPage}
      />
      <AdminHomeHistorySimplePanel
        items={currentPageItems}
      />
    </div>
  );
};
